import { useMemo, useState } from 'react';

/** wrapper for `useState()`. initialises the value from the URL search parameters or other default params. */
export default function useSearchField(name: string, params?: {}): [string | undefined, (value: string) => void] {
    // Initially, try to load the value from the SearchProfile, otherwise from the URL.
    const initial = useMemo(() => {
        const match = location.search.match(`\\b${name}=([^&]+)&?`);
        const value = match ? decodeURIComponent(match[1]) : params && params[name] || '';

        return value;
    }, [location.search, params]);
    const [state, setState] = useState<string>(initial);

    // If the SearchProfile is initially undefined and is subsequently provided then we want the URL to still have precedence.
    if (!state && !initial && params && params[name]) {
        setState(params[name]);
    }

    return [state, setState];
}
